import { OrderableItems } from "@/components";
import * as S from "@/sharedStyled";
import { DEFAULT_FONT_SIZE } from "@/sharedStyled/config";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faBars } from "@fortawesome/pro-solid-svg-icons";
import { Card } from "antd";
import { IOrderable } from "./interfaces";

interface IProps<T> extends IOrderable<T> {
  item: T;
  orderingDisabled: boolean;
}

const OrderableItem = <T,>({
  item,
  idKey,
  nameKey,
  nestedDataKey,
  setItems,
  orderingDisabled,
}: IProps<T>) => {
  const id = idKey(item);
  const nestedData: T[] | undefined = nestedDataKey && nestedDataKey(item);

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id, disabled: orderingDisabled });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
  };

  return (
    <li
      ref={setNodeRef}
      style={style}
      {...attributes}
      className="aria-pressed:relative aria-pressed:z-[999]"
    >
      <Card
        size="small"
        title={
          <S.SizedText fontSize={DEFAULT_FONT_SIZE} className="font-[initial]">
            {nameKey(item)}
          </S.SizedText>
        }
        extra={
          !orderingDisabled && (
            <S.DragIcon
              icon={faBars as IconProp}
              className="float-right p-2"
              {...listeners}
            />
          )
        }
        styles={!nestedData?.length ? { body: { padding: 0 } } : undefined}
      >
        {!!nestedData?.length && (
          <OrderableItems
            items={nestedData}
            setItems={setItems}
            parentId={id}
            idKey={idKey}
            nameKey={nameKey}
            nestedDataKey={nestedDataKey}
          />
        )}
      </Card>
    </li>
  );
};

export default OrderableItem;
